import { getCustomLogo, getPartnerLogo } from "./partnerLogos";

import { ComponentPropsWithoutRef } from "react";
import { Partner } from "Store/partners/partnerInterfaces";

type ReactImage = ComponentPropsWithoutRef<"img">;

interface FooterProps {
  show: {
    finansportalen: boolean;
  };
  addons?: {
    logo: ReactImage;
    text?: string;
  };
}

export const getFooterPartnerProps = (partnerId: Partner): FooterProps => {
  switch (partnerId) {
    case Partner.COOP:
      return FOOTER_COOP_PROPS;
    case Partner.DANSKE_BANK:
      return FOOTER_DANSKE_BANK_PROPS;
    case Partner.HUSEIERNE:
      return FOOTER_HUSEIERNE_PROPS;
    default:
      return { show: { finansportalen: true } };
  }
};

const FOOTER_COOP_PROPS: FooterProps = {
  show: {
    finansportalen: true,
  },
  addons: {
    logo: {
      src: getCustomLogo("beta/storebrand-logo-desktop"),
      alt: "Storebrand",
      height: "16px",
    },
  },
};

const FOOTER_DANSKE_BANK_PROPS: FooterProps = {
  show: {
    finansportalen: true,
  },
  addons: {
    logo: {
      src: getPartnerLogo(Partner.STOREBRAND),
      alt: "Storebrand",
      height: "16px",
    },
  },
};

const FOOTER_HUSEIERNE_PROPS: FooterProps = {
  show: {
    finansportalen: true,
  },
  addons: {
    logo: {
      src: getCustomLogo("beta/storebrand-logo-desktop"),
      alt: "Storebrand",
      height: "16px",
    },
  },
};
